/**
 * All theme vendor dependencies
 */
window.$ = window.jQuery = require('../../HTML/vendor/jquery/jquery');
window.Popper = require('../../HTML/vendor/popper/umd/popper.min');
require('imports-loader?this=>window!exports-loader?window.Modernizr!../../HTML/vendor/modernizr/modernizr');

require('../../HTML/vendor/jquery-browser-mobile/jquery.browser.mobile');
require('../../HTML/vendor/bootstrap/js/bootstrap');
require('../../HTML/vendor/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../HTML/vendor/common/common');
require('../../HTML/vendor/nanoscroller/nanoscroller');
require('../../HTML/vendor/magnific-popup/jquery.magnific-popup');
require('../../HTML/vendor/jquery-placeholder/jquery-placeholder');
require('../../HTML/vendor/datatables/media/js/jquery.dataTables');



// WEBPACK FOOTER //
// ./node_modules/porto-admin/build/script/vendor.js